import { Injectable } from '@angular/core';
import { WebApiClient } from '../../web-api-client.service';
import { Router } from '@angular/router';
import { RouteInfoService } from '../../route-info.service';
import { WebApiService } from '../../web-api.service';
import { MenuDto, MenuSyncParam, MenuTree, MenuViewDto } from './menu-api.model';
import { CustomResult } from 'src/app/shared/models/custom-result';
import { LoginMenu } from 'src/app/permission/models/login-menu';

@Injectable({
  providedIn: 'root'
})
export class MenuApiService {

  apiService: WebApiService;

  constructor(private webApiFactory: WebApiClient) {
    this.apiService = this.webApiFactory.createHisService('permission/menu');
    this.apiService.enableLoader = false;
  }

  get(id: number): Promise<MenuDto> {
    return this.apiService.get(`Get/${id}`).toPromise<MenuDto>();

  }
  /** 當前使用者 */
  GetMenu(): Promise<{data:LoginMenu}> {
    return this.apiService.get(`GetMenu`).toPromise();

  }

  getView(id: number): Promise<MenuViewDto> {
    return this.apiService.get(`GetView/${id}`).toPromise<MenuViewDto>();

  }

  getTree(): Promise<MenuTree> {
    return this.apiService.get('GetTree').toPromise<MenuTree>();
  }

  getTreeCompany(companyId?: number): Promise<MenuTree> {
    let path = "GetTreeCompany";
    if (companyId && companyId != 0) {
      path = `${path}?companyId=${companyId}`;

    }
    return this.apiService.get(path).toPromise<MenuTree>();
  }

  syncMenu(param: MenuSyncParam): Promise<CustomResult> {
    return this.apiService.post("SyncMenu", param).toPromise<CustomResult>();
  }
}
